export default __webpack_public_path__ + "static/media/Hvac-sample.37b636d0.jpeg";